<template>
  <div>
    <!-- Page content -->
    <b-container>
      <b-row class="justify-content-center mt-5 mb-5">
        <b-col lg="5" md="7">
          <b-card no-body>
            <b-card-body class="px-lg-5 py-lg-5">
              <div class="text-center text-muted mb-4">
                <div class="auth-logo">
                  <img src="@/assets/img/moolah-icon-blue-lg.png" />
                </div>
                <small
                  >To reset your password, please enter the email address used
                  to setup your account.</small
                >
              </div>
              <validation-observer
                v-slot="{ handleSubmit }"
                ref="formValidator"
              >
                <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
                  <base-input
                    class="mb-3"
                    name="email"
                    ref="email"
                    mode="lazy"
                    prepend-icon="fa-solid fa-envelope"
                    placeholder="Email"
                    v-model="model.email"
                  >
                  </base-input>

                  <div class="text-center">
                    <base-button
                      type="primary"
                      native-type="submit"
                      class="my-4 btn-block font-weight-bold"
                      >Email Password Reset</base-button
                    >
                  </div>
                </b-form>
              </validation-observer>
            </b-card-body>
          </b-card>
          <b-row class="mt-4">
            <b-col cols="12">
              <small
                ><router-link to="/login" class="text-muted"
                  >Back to Login</router-link
                ></small
              >
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
export default {
  inject: ["systemContextService"],
  data() {
    return {
      logo: null,
      model: {
        email: "",
      },
    };
  },
  created() {
    this.logo = this.systemContextService.getSystem().dashboardImageUrl;
  },
  methods: {
    onSubmit() {
      var self = this;

      this.$emitter.on("response-validationErrors", (e) => {
        self.$refs.formValidator.setErrors(e.errors);
      });

      this.$client
        .post("/api/auth/resetPassword", this.model)
        .then((response) => {
          if (response.data.isSuccess) {
            let m = {
              title: "Password Reset",
              message:
                "A link has been sent to " +
                self.model.email +
                " to reset your password.",
            };
            self.$emitter.emit("success", m);
          }
        });
    },
  },
};
</script>
<style lang="scss"></style>
